import {
	GET_HOMEPAGE_ERROR,
	GET_HOMEPAGE_SUCCESS,
	GET_HOMEPAGE
} from './constants';

import { fromJS } from 'immutable';

import camelcase from 'camelize';

import { get, mapKeys, replace, merge } from 'lodash';

const initialState = fromJS({
	homepage: null,
	homepageLoading: null,
	homepageLoadingError: null
});

function homepageReducer(state = initialState, action) {
	let homepage;
	let data;
	switch (action.type) {
		case GET_HOMEPAGE:
			return state
				.set('homepageLoading', true)
				.set('homepageLoadingError', false)
				.set('homepage', null);

		case GET_HOMEPAGE_SUCCESS:
			data = action.isHomepageTest ? get(action.data, 'data[0].attributes') : action.data;
			homepage = mapKeys(get(data, 'content'), (value, key) => replace(key, 'homepage_2020_', ''));
			['mobile', 'tablet', 'desktop'].forEach((item) => {
				homepage[item] = get(homepage, item, []).map((module, index) => merge({ urlTitle: get(module, 'url_title'), title: get(module, 'title'), id: get(module, 'id'), position: index + 1 }, mapKeys(get(module, 'content', {}), (value, key) => replace(key, 'homepage_2020_', ''))));
			});
			homepage.url_title = get(data, 'url_title');
			homepage = camelcase(homepage);
			return state
				.set('homepage', homepage)
				.set('homepageLoadingError', false)
				.set('homepageLoading', false);

		case GET_HOMEPAGE_ERROR:
			return state
				.set('homepageLoadingError', action.error)
				.set('homepageLoading', false);

		default:
			return state;
	}
}

export default homepageReducer;
